import { IconPack } from "Admin/Config/Icon";
import { unit_level_colors } from "Admin/Config/UnitLevel";
import { numberRegex } from "Admin/Utils/numberRegex";
import { Tag } from "antd";
import { LinkWrapper } from "..";
import styles from "./UnitCard.module.scss";
const UnitCard = ({ data }) => {
  return (
    <LinkWrapper
      link={`/admin/units/${data.id}-${data.level}/summary`}
      component={
        <div className={styles["unit-card"]}>
          <div className={styles["unit-title"]}>
            <p>{data.name}</p>
            <Tag color={unit_level_colors[data.level - 1]}>
              Level {data.level}
            </Tag>
          </div>
          <div className={styles["statistic"]}>
            {IconPack.faculty_member}
            <p>
              <span>{numberRegex(data.total_faculties)}</span> Faculty members
            </p>
          </div>
          <div className={styles["statistic"]}>
            {IconPack.publications}
            <p>
              <span>{numberRegex(data.total_publication)}</span> Publications
            </p>
          </div>
        </div>
      }
    />
  );
};

export default UnitCard;
